import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useTranslation } from 'react-i18next';
import { DraftLineItemsPage as DraftLineItemsPageNew } from '../../../features/sales-draft-new/views/draft-line-items-page.tsx';

export function useDraftLineItemsAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    return usePageAiMeta({
        path: '/drafts/:draft_id/line-items',
        title: t('sales_draft__stepper__line_items', { ns: 'sales-draft' }),
        requiresTransactionDrafts: true,
        description:
            'The line items step of a sales draft. Search products and add them, set quantity, ' +
            'price and discount per line, see a backorder warning when stock runs short, then ' +
            'continue to the header step. Some tenants do not have drafts; if the user cannot see ' +
            'the page, it is not enabled for them.',
    });
}

function DraftLineItems() {
    return <DraftLineItemsPageNew />;
}

export default DraftLineItems;
